import React, { FunctionComponent, MouseEvent } from "react";
import Marked from "../../public/assets/checkbox-marked.svg";
import Outline from "../../public/assets/checkbox-blank-outline.svg";
import Exclude from "../../public/assets/checkbox-exclude.svg";

type CheckboxProps = {
  checked: boolean | "exclude";
  onClick: (newStatus: boolean | "exclude", event: MouseEvent) => void;
  excludeOption?: boolean;
  error?: boolean;
  dark?: boolean;
};

const Checkbox: FunctionComponent<CheckboxProps> = ({
  checked,
  onClick,
  children,
  excludeOption,
  error,
  dark,
}) => {
  const nextValue = () => {
    if (!excludeOption) {
      return !checked;
    } else {
      if (checked === true) {
        return "exclude";
      } else if (checked === "exclude") {
        return false;
      } else {
        return true;
      }
    }
  };

  return (
    <button
      className={"checkbox" + (error ? " error" : "") + (dark ? " dark" : "")}
      onClick={(e) => onClick(nextValue(), e)}
      type={"button"}
    >
      <div
        className={
          "checkbox-container" +
          (checked === true ? " checked" : "") +
          (checked === "exclude" ? " excluded" : "")
        }
      >
        <div className={"check"}>
          <Marked />
        </div>
        <div className={"outline"}>
          <Outline />
        </div>
        <div className="exclude">
          <Exclude />
        </div>
      </div>
      <div className="text">{children}</div>
    </button>
  );
};

export default Checkbox;
